<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import { formatDateTimeBr } from '@/@core/utils/filter'
import { mapGetters } from 'vuex'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'

const resolveUserRoleVariant = role => {
  if (role === 'Admin B2B') return 'primary'
  if (role === 'Cliente B2B') return 'warning'
  if (role === 'Admin') return 'danger'
  return 'primary'
}

const resolveUserRoleIcon = role => {
  if (role === 'Cliente B2B') return 'UserIcon'
  if (role === 'Admin B2B') return 'SettingsIcon'
  if (role === 'Admin') return 'ServerIcon'
  return 'UserIcon'
}
export default {
  components: {
    StatisticCardHorizontal,
    BRow,
    BCol,
  },
  filters: {
    formatDateTimeBr,
  },
  computed: {
    ...mapGetters({
      dataRoles: 'appGruposPermissions/GET_GROUPS',
    }),
  },
  methods: {
    resolveUserRoleVariant,
    resolveUserRoleIcon,
  },
  mounted() {
    this.$store.dispatch('appGruposPermissions/FIND_GROUPS')
  },
}
</script>

<template>
  <b-row>
    <b-col
      v-for="(item, index) in dataRoles"
      :key="index"
      xl="4"
      sm="4"
    >
      <statistic-card-horizontal
        :statistic="item.grupousuario"
        :color="resolveUserRoleVariant(item.grupousuario)"
        :icon="resolveUserRoleIcon(item.grupousuario)"
        :statistic-title="`Total ${item.usuarios.length} usuários`"
      />
    </b-col>
  </b-row>

</template>

<style scoped lang="scss">

</style>
